module.exports = __webpack_public_path__ + "static/img/ssy.87c81a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/ssy.png
// module id = 4VFU
// module chunks = 64